import React, { useState, useEffect } from "react";
import { Text, TextArea } from "../../formitems/Index";
import { LeftOutlined, DownOutlined } from "@ant-design/icons";
import firebase from "../../../Firebase/firebase";
import {
  Fleet,
  getClientId,
  Phase,
  Simulator_Query,
  Aircraft_Query,
  Edit_simulator,
  Edit_aircraft,
  Insert_TC_Simulator,
  Insert_TC_Aircraft,
} from "../../../Queries/Manager Query/TechnicalCompitency/TechnicalCompitency";
import { useQuery, useMutation } from "@apollo/client";
import { Menu, Dropdown, InputNumber, notification, Select } from "antd";
import { Link } from "react-router-dom";
import TCAircraft from "./TCAircraft";
import TCSimulator from "./TCSimulator";
const TechnicalCompetency = () => {
  const [search, setsearch] = useState("");
  const [add_new_technical_comp, setadd_new_technical_comp] = useState(false);
  const [dropdown, setdropdown] = useState("");
  const [phace, setphace] = useState("");
  const [catagories, setcatagories] = useState("");
  const [users, setusers] = useState({});
  const [isEdit, setisEdit] = useState(false);
  const [isView, setisView] = useState(false);
  const [newphase, setnewphase] = useState("");
  const [phses, setphses] = useState("");
  const [catagory, setcatagory] = useState("");
  const [fleetss, setfleetss] = useState("");
  const [stcname, setstcname] = useState("");
  const [shortname, setshortname] = useState("");
  const [CurrentFormData, setCurrentFormData] = useState({});
  const [validity, setvalidity] = useState(0);
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);
  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data: getFleet } = useQuery(Fleet, {
    variables: { id: getclient?.aatmsv4_users[0]?.client?.clientsid },
  });
  const { data: phases } = useQuery(Phase);
  const { data: Simulator_Queries } = useQuery(Simulator_Query, {
    variables: {
      id: getclient?.aatmsv4_users[0]?.client?.clientsid,
      fleetId: dropdown,
      phases: phace,
    },
  });
  const { data: Aircraft_Queries } = useQuery(Aircraft_Query, {
    variables: {
      id: getclient?.aatmsv4_users[0]?.client?.clientsid,
      fleetId: dropdown,
      phases: phace,
    },
  });
  const [editSimulator, { data: edit_Simulatorss }] = useMutation(
    Edit_simulator,
    {
      refetchQueries: [
        {
          query: Simulator_Query,
          variables: {
            id: getclient?.aatmsv4_users[0]?.client?.clientsid,
            fleetId: dropdown,
            phases: phace,
          },
        },
      ],
    }
  );
  const [editaircraft, { data: edit_aircrafts }] = useMutation(Edit_aircraft, {
    refetchQueries: [
      {
        query: Aircraft_Query,
        variables: {
          id: getclient?.aatmsv4_users[0]?.client?.clientsid,
          fleetId: dropdown,
          phases: phace,
        },
      },
    ],
  });
  const [Insert_tc, { data: InsertTcSimulator }] = useMutation(
    Insert_TC_Simulator,
    {
      refetchQueries: [
        {
          query: Simulator_Query,
          variables: {
            id: getclient?.aatmsv4_users[0]?.client?.clientsid,
            fleetId: fleetss,
            phases: phses,
          },
        },
      ],
    }
  );
  const [Insert_tc_aircraft, { data: insert }] = useMutation(
    Insert_TC_Aircraft,
    {
      refetchQueries: [
        {
          query: Aircraft_Query,
          variables: {
            id: getclient?.aatmsv4_users[0]?.client?.clientsid,
            fleetId: fleetss,
            phases: phses,
          },
        },
      ],
    }
  );
  const EditTC = () => {
    setisEdit(true);
  };
  const View = () => {
    setisView(true);
  };
  const menu = (el) => (
    <Menu>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(el);
            EditTC();
          }}
        >
          Edit
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(el);
            View();
          }}
        >
          View
        </Link>
      </Menu.Item>
    </Menu>
  );
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "atcshortname" || "stcshortname":
        setCurrentFormData({ ...CurrentFormData, atcshortname: v });
        break;
      case "stcshortname":
        setCurrentFormData({ ...CurrentFormData, stcshortname: v });
        break;
      case "stcname":
        setCurrentFormData({ ...CurrentFormData, stcname: v });
        break;
      case "atcname":
        setCurrentFormData({ ...CurrentFormData, atcname: v });
        break;
      case "true":
        setCurrentFormData({ ...CurrentFormData, active: v });
        break;
      default:
        break;
    }
  };
  const add_new = () => {
    setadd_new_technical_comp(true);
  };
  const closeForm = () => {
    setadd_new_technical_comp(false);
    setisView(false);
    setisEdit(false);
  };
  function onChange(value) {
    setvalidity(value);
  }
  const Option = Select.Option;
  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Successfully Added Fleet",
      description: "Successfully Added Techincal Competency Thank you.",
    });
  };

  const UpdateNotificationWithIcon = (type) => {
    notification[type]({
      message: "Successfully ",
      description: `Successfully Update fields`,
    });
  };
  const PrintNotificationWithIcon = (type) => {
    notification[type]({
      message: "Successfully ",
      description: `Successfully Print Technical Competency`,
    });
  };
  return (
    <div className="animate__animated animate__fadeIn">
      {/* Technical Competency Table */}
      <div
        className={
          "technical-competency-container " +
          (add_new_technical_comp || isEdit || isView ? "hide-element" : "")
        }
      >
        <div className="category-title">Technical Competency</div>
        <button className="submit-button" onClick={add_new}>
          Add New Technical Competency
        </button>
        <div className="table-body-container">
          <div className="table-body-header">Add New Technical Competency</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                <Select
                  defaultValue="Select Fleets"
                  onChange={(e) => setdropdown(e)}
                >
                  {getFleet?.aatmsv4_fleets?.map((el, index) => (
                    <Option key={index} value={el.fleetsid}>
                      {el.aircraft}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="active-switch">
                <Select
                  defaultValue="Select Phase"
                  onChange={(e) => setphace(e)}
                >
                  {phases?.aatmsv4_phase?.map((el, index) => (
                    <Option key={index} value={el.phaseid}>
                      {el.phaseid}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="active-switch">
                <Select
                  defaultValue="Select Catagory"
                  onChange={(e) => setcatagories(e)}
                >
                  <Option value="Simulator">Simulator</Option>
                  <Option value="Aircraft">Aircraft</Option>
                  ))
                </Select>
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>
            {catagories === "Simulator" ? (
              <TCSimulator
                data={Simulator_Queries}
                search={search}
                DownOutlined={DownOutlined}
                menu={menu}
                Dropdown={Dropdown}
              />
            ) : null}
            {catagories === "Aircraft" ? (
              <TCAircraft
                data={Aircraft_Queries}
                search={search}
                DownOutlined={DownOutlined}
                menu={menu}
                Dropdown={Dropdown}
              />
            ) : null}
          </div>
        </div>
        {/* <div className="print-email-container">
          <button className="submit-button" style={{ marginTop: "unset" }}>
            <i className="fa fa-download" />
              Download
            </button>
          <button className="print-button">
            <i className="fa fa-print" />
              Print
            </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
              Email
            </button>
        </div> */}
      </div>
      {/* add new competency form */}
      <div className={add_new_technical_comp ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Technical Competency
          </span>
          Add New Technical Competency
        </div>
        <div className="toggle-form-container">
          <span>Select Fleets:</span>
          <Select value={fleetss} onChange={(e) => setfleetss(e)}>
            {getFleet?.aatmsv4_fleets?.map((el, index) => (
              <Option key={index} value={el.fleetsid}>
                {el.aircraft}
              </Option>
            ))}
          </Select>
          <span>Select Catagory:</span>
          <Select value={catagory} onChange={(e) => setcatagory(e)}>
            <Option value="Simulator">Simulator</Option>
            <Option value="Aircraft">Aircraft</Option>))
          </Select>
          <span>Select Phase:</span>
          <Select value={phses} onChange={(e) => setphses(e)}>
            {phases?.aatmsv4_phase?.map((el, index) => (
              <Option key={index} value={el.phaseid}>
                {el.phaseid}
              </Option>
            ))}
          </Select>
          <span>ata number:</span>
          <br />
          <InputNumber
            size="large"
            style={{ width: "100%" }}
            min={0}
            max={9999}
            defaultValue={validity}
            onChange={onChange}
          />
          <br />
          <br />
          <Text
            title="Short Name"
            value={shortname}
            onChange={(e) => setshortname(e.target.value)}
          />
          <TextArea
            rows="3"
            title="Description"
            value={stcname}
            onChange={(e) => setstcname(e.target.value)}
          />
          <Text title="Active" value="Yes" disabled />
          <button
            className="submit-button"
            onClick={() => {
              if (catagory === "Simulator") {
                Insert_tc({
                  variables: {
                    clientId: getclient?.aatmsv4_users[0]?.client?.clientsid,
                    clientName: getclient?.aatmsv4_users[0]?.client?.clientname,
                    fleetId: fleetss,
                    phase: phses,
                    shortName: shortname,
                    stcName: stcname,
                    ata: validity,
                  },
                });
              } else if (catagory === "Aircraft") {
                Insert_tc_aircraft({
                  variables: {
                    clientId: getclient?.aatmsv4_users[0]?.client?.clientsid,
                    clientName: getclient?.aatmsv4_users[0]?.client?.clientname,
                    fleetId: fleetss,
                    phase: phses,
                    shortName: shortname,
                    stcName: stcname,
                    ata: validity,
                  },
                });
              }
              setfleetss("");
              setcatagory("");
              setphses("");
              setvalidity(0);
              setshortname("");
              setstcname("");
              closeForm();
              openNotificationWithIcon("success");
            }}
          >
            Add
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
      <div className={isEdit ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Technical Competency Edit
          </span>
          Technical Competency Edit
        </div>
        <div className="toggle-form-container">
          <p>
            Current Phase: <b>{CurrentFormData.phase}</b>
          </p>
          <Select defaultValue="Select Phase" onChange={(e) => setnewphase(e)}>
            {phases?.aatmsv4_phase?.map((el, index) => (
              <Option key={index} value={el.phaseid}>
                {el.phaseid}
              </Option>
            ))}
          </Select>
          {catagories === "Simulator" ? (
            <Text
              title="Short Name"
              value={CurrentFormData?.stcshortname}
              onChange={(e) => handleFormFields(e.target.value, "stcshortname")}
            />
          ) : null}
          {catagories === "Aircraft" ? (
            <Text
              title="Short Name"
              value={CurrentFormData?.atcshortname}
              onChange={(e) => handleFormFields(e.target.value, "atcshortname")}
            />
          ) : null}
          {catagories === "Simulator" ? (
            <TextArea
              rows="3"
              title="Description"
              value={CurrentFormData?.stcname}
              onChange={(e) => handleFormFields(e.target.value, "stcname")}
            />
          ) : null}
          {catagories === "Aircraft" ? (
            <TextArea
              rows="3"
              title="Description"
              value={CurrentFormData?.atcname}
              onChange={(e) => handleFormFields(e.target.value, "atcname")}
            />
          ) : null}
          <Select
            defaultValue={CurrentFormData.active === true ? "No" : "Yes"}
            onChange={(e) => handleFormFields(e, "true")}
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
          <button
            className="submit-button"
            onClick={() => {
              if (catagories === "Simulator") {
                editSimulator({
                  variables: {
                    id: CurrentFormData.stcid,
                    phse: newphase === "" ? CurrentFormData.phase : newphase,
                    shortname: CurrentFormData.stcshortname,
                    name: CurrentFormData?.stcname,
                    active: CurrentFormData.active,
                  },
                });
              } else if (catagories === "Aircraft") {
                editaircraft({
                  variables: {
                    id: CurrentFormData.atcid,
                    phse: newphase === "" ? CurrentFormData.phase : newphase,
                    shortname: CurrentFormData.atcshortname,
                    name: CurrentFormData?.atcname,
                    active: CurrentFormData.active,
                  },
                });
              }
              closeForm();
              UpdateNotificationWithIcon("success");
            }}
          >
            Update
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
      <div className={isView ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Technical Competency View
          </span>
          Technical Competency
        </div>
        <div className="toggle-form-container">
          <Text title="Phase" value={CurrentFormData?.phase} disabled />
          <Text
            title="Short Name"
            value={
              CurrentFormData?.stcshortname || CurrentFormData?.atcshortname
            }
            disabled
          />
          <TextArea
            title="Description"
            rows="3"
            value={CurrentFormData?.stcname || CurrentFormData?.atcname}
            disabled
          />
          <Text
            title="Active"
            value={CurrentFormData.active === true ? "Yes" : "No"}
            disabled
          />
          <button
            className="submit-button"
            onClick={() => {
              PrintNotificationWithIcon("success");
            }}
          >
            Add
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
export default TechnicalCompetency;
